export interface MenuItems {
  home: boolean
  addImage: boolean
  view: boolean
  zoom: boolean
  colorScale: boolean
  overlay: boolean
  header: boolean
  navigation?: boolean
  saveScene?: boolean
}

export interface NiiVueSettings {
  showCrosshairs: boolean
  interpolation: boolean
  colorbar: boolean
  radiologicalConvention: boolean
  zoomDragMode: boolean
  defaultVolumeColormap: string
  defaultOverlayColormap: string
  defaultOverlayOpacity: number
  defaultMeshOverlayColormap: string
  menuItems?: MenuItems
}

export const defaultSettings: NiiVueSettings = {
  showCrosshairs: true,
  interpolation: true,
  colorbar: false,
  radiologicalConvention: false,
  zoomDragMode: false,
  defaultVolumeColormap: 'gray',
  defaultOverlayColormap: 'redyell',
  defaultOverlayOpacity: 0.5,
  defaultMeshOverlayColormap: 'hsv',
  menuItems: {
    home: true,
    addImage: true,
    view: true,
    zoom: true,
    colorScale: true,
    overlay: true,
    header: true,
    navigation: true,
    saveScene: true,
  },
}
